import { FC } from "react";

import { ConfirmDeleteOneModal } from "src/components/Modal";
import { useToast } from "src/components/Toasts/ToastContainer.tsx";
import { mapToModalError } from "src/errors";
import {
  DeleteRuleMutation,
  DeleteRuleMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { getRulesQuery } from "src/graphql/anti-fraud/queries/rules/GetRulesQuery.ts";
import { deleteRuleMutation } from "src/graphql/anti-fraud/queries/rules/mutations/DeleteRuleMutation.ts";
import { usePerformMutation } from "src/graphql/utils";
import { useT } from "src/internationalization";
import { Rule } from "src/types/rule";

type DeleteRuleModalProps = {
  ruleToDelete: Rule;
  onClose: () => void;
};

export const DeleteRuleModal: FC<DeleteRuleModalProps> = ({ ruleToDelete, onClose }) => {
  const { showSuccessToast } = useToast();
  const t = useT();

  const {
    loading: isDeleting,
    error: deleteError,
    performMutation: handleDelete,
  } = usePerformMutation<DeleteRuleMutation, DeleteRuleMutationVariables>(deleteRuleMutation, {
    onSuccess: () => {
      onClose();
      showSuccessToast(t("page.rules.modal.delete.toast.success.message"));
    },
    mutationOption: {
      refetchQueries: [{ query: getRulesQuery }],
      awaitRefetchQueries: true,
    },
  });

  const handleOnConfirm = async () => {
    await handleDelete({ id: ruleToDelete.id });
  };

  return (
    <ConfirmDeleteOneModal
      resourceName={ruleToDelete.name}
      onConfirm={handleOnConfirm}
      loading={isDeleting}
      error={mapToModalError(deleteError)}
      onClose={onClose}
    />
  );
};
